import React from 'react'
import { Col, Row, Table } from 'react-bootstrap'


class TableFixed extends React.Component {
    render() {
        return (

            <>
                <Row>
                    <Col className='table-responsive'>

                        <Table className='table-striped table-hover mb-0'>
                            <thead>
                                <tr key={0}>
                                    {
                                        this.props.title.map(item => {
                                            return (
                                                <th className={`text-${item.align}`}>{item.title}</th>
                                            )
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.props.data ?
                                        this.props.data.map((row, key) => (
                                            <tr key={key+1}>
                                                {
                                                    Object.values(row).map((item, key) => {
                                                        return (
                                                            <td className={`text-${this.props.title[key].align}`}>{item}</td>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        ))
                                        : (
                                            <tr key={1}>
                                                <td
                                                    colspan={this.props.title.length}
                                                    className='text-center'
                                                >Nenhum resultado encontrado</td>
                                            </tr>
                                        )

                                }
                            </tbody>
                        </Table>

                    </Col>
                </Row >
            </>

        )
    }
}

export default TableFixed;




